/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Ota_Check_FailedInputs */

const en_mobile_ota_check_failed = /** @type {(inputs: Mobile_Ota_Check_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update check failed`)
};

const es_mobile_ota_check_failed = /** @type {(inputs: Mobile_Ota_Check_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falló la comprobación de actualización`)
};

/**
* | output |
* | --- |
* | "Update check failed" |
*
* @param {Mobile_Ota_Check_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_ota_check_failed = /** @type {((inputs?: Mobile_Ota_Check_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Ota_Check_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_ota_check_failed(inputs)
	return en_mobile_ota_check_failed(inputs)
});